<template>
    <div class="app-container">
        <!-- 筛选区 -->
        <div class="flex flex-j-s flex-wrap">
            <div class="flex flex-a-c mb-20">
                <div class="title">用电量统计</div>

                <el-select v-model="filter.provinceId" class="input-mini ml-10" placeholder="省">
                    <el-option label="全部" value="-1" />
                    <el-option v-for="item in provinceList" :key="item.Id" :label="item.Name" :value="item.Id" />
                </el-select>

                <el-select v-model="filter.cityId" class="input-mini ml-10" placeholder="市">
                    <el-option label="全部" value="-1" />
                    <el-option v-for="item in cityList" :key="item.Id" :label="item.Name" :value="item.Id" />
                </el-select>

                <el-select v-model="filter.areaId" class="input-mini ml-10" placeholder="区">
                    <el-option label="全部" value="-1" />
                    <el-option v-for="item in areaList" :key="item.Id" :label="item.Name" :value="item.Id" />
                </el-select>

                <el-select v-model="filter.stationId" class="input-medium ml-10" placeholder="站点">
                    <el-option label="全部" value="-1" />
                    <el-option v-for="item in stationList" :key="item.Id" :label="item.Name" :value="item.Id" />
                </el-select>
            </div>

            <!-- 时间筛选 -->
            <div class="flex mb-20">
                <el-select v-model="filter.timeLabel" class="input-mini ml-10">
                    <el-option label="日" value="1" />
                    <el-option label="月" value="2" />
                    <el-option label="年" value="3" />
                </el-select>

                <el-date-picker v-if="filter.timeLabel === '1'" v-model="filter.dateRange" type="daterange"
                    value-format="yyyy-MM-dd" class="ml-10" />

                <el-date-picker v-if="filter.timeLabel === '2'" v-model="filter.dateRange" type="monthrange"
                    value-format="yyyy-MM" class="ml-10" />

                <div v-if="filter.timeLabel === '3'" class="flex flex-a-c ml-10">
                    <el-date-picker v-model="filter.startYear" type="year" value-format="yyyy" />
                    <span class="ml-10 mr-10">至</span>
                    <el-date-picker v-model="filter.endYear" type="year" value-format="yyyy" />
                </div>

                <el-button class="ml-10" type="primary" @click="loadData">查询</el-button>
            </div>
        </div>

        <!-- 统计卡片 -->
        <el-row :gutter="20" class="mb-20">
            <el-col :span="6">
                <el-card shadow="hover">
                    <div class="stat-title">总用电量</div>
                    <div class="stat-value">128,600 kWh</div>
                    <div class="stat-desc">↑ 12% 同比</div>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="hover">
                    <div class="stat-title">尖段电量</div>
                    <div class="stat-value">15,800 kWh</div>
                    <div class="stat-desc">占比 12.3%</div>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="hover">
                    <div class="stat-title">峰段电量</div>
                    <div class="stat-value">52,300 kWh</div>
                    <div class="stat-desc">占比 40.7%</div>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="hover">
                    <div class="stat-title">平段电量</div>
                    <div class="stat-value">48,100 kWh</div>
                    <div class="stat-desc">占比 37.4%</div>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="hover">
                    <div class="stat-title">谷段电量</div>
                    <div class="stat-value">28,200 kWh</div>
                    <div class="stat-desc">↓ 3% 环比</div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 图表区 -->
        <el-row :gutter="20" v-loading="chartLoading">
            <!-- 折线图 -->
            <el-col :span="24">
                <el-card shadow="hover">
                    <div ref="lineChart" style="height: 340px"></div>
                </el-card>
            </el-col>

            <!-- 柱状图 -->
            <el-col :span="12">
                <el-card class="mt-20" shadow="hover">
                    <div ref="barChart" style="height: 340px"></div>
                </el-card>
            </el-col>

            <!-- 条形图 -->
            <el-col :span="12">
                <el-card class="mt-20" shadow="hover">
                    <div ref="horizontalBar" style="height: 340px"></div>
                </el-card>
            </el-col>

            <!-- 饼图区 -->
            <el-col :span="24">
                <el-row :gutter="20" class="mt-20">
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <div ref="pieChartTotal" style="height: 360px"></div>
                        </el-card>
                    </el-col>

                    <el-col :span="8">
                        <el-card shadow="hover">
                            <div ref="pieChartStation" style="height:360px"></div>
                        </el-card>
                    </el-col>

                    <!-- ✅ 用电来源构成 -->
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <div ref="pieChartSource" style="height: 360px"></div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
    name: 'PowerUsageChart',
    data() {
        const today = this.getToday()
        const yesterday = this.getYesterday()
        return {
            filter: {
                provinceId: '-1',
                cityId: '-1',
                areaId: '-1',
                stationId: '-1',
                timeLabel: '1',
                dateRange: [yesterday, today],
                startYear: '',
                endYear: ''
            },
            provinceList: [],
            cityList: [],
            areaList: [],
            stationList: [],
            chartLoading: false,

            lineChart: null,
            barChart: null,
            horizontalBar: null,
            pieChartTotal: null,
            pieChartStation: null,
            pieChartSource: null
        }
    },
    mounted() {
        this.initCharts()
        this.loadData()
    },
    methods: {
        getToday() {
            const d = new Date()
            const year = d.getFullYear()
            const month = String(d.getMonth() + 1).padStart(2, '0')
            const day = String(d.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        getYesterday() {
            const d = new Date()
            const year = d.getFullYear()
            const month = String(d.getMonth() + 1).padStart(2, '0')
            const day = String(d.getDate()-1).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        initCharts() {
            this.lineChart = echarts.init(this.$refs.lineChart)
            this.barChart = echarts.init(this.$refs.barChart)
            this.horizontalBar = echarts.init(this.$refs.horizontalBar)
            this.pieChartTotal = echarts.init(this.$refs.pieChartTotal)
            this.pieChartStation = echarts.init(this.$refs.pieChartStation)
            this.pieChartSource = echarts.init(this.$refs.pieChartSource)
        },

        loadData() {
            this.chartLoading = true
            setTimeout(() => {
                this.renderLineChart()
                this.renderBarChart()
                this.renderHorizontalBar()
                this.renderPieChartTotal()
                this.renderPieChartStation()
                this.renderPieChartSource()
                this.chartLoading = false
            }, 800)
        },

        renderLineChart() {
            this.lineChart.setOption({
                title: { text: '用电趋势（kWh）', left: 'center' },
                tooltip: { trigger: 'axis' },
                legend: { top: 30, data: ['实际用电', '预测用电'] },
                xAxis: {
                    type: 'category',
                    data: ['1日', '2日', '3日', '4日', '5日', '6日', '7日']
                },
                yAxis: { type: 'value' },
                series: [
                    {
                        name: '实际用电',
                        type: 'line',
                        smooth: true,
                        data: [120, 200, 150, 80, 70, 110, 130],
                        areaStyle: {}
                    },
                    {
                        name: '预测用电',
                        type: 'line',
                        smooth: true,
                        data: [110, 180, 160, 90, 60, 100, 140]
                    }
                ]
            })
        },

        renderBarChart() {
            this.barChart.setOption({
                title: { text: '站点用电对比（尖 / 峰 / 平 / 谷）', left: 'center' },
                tooltip: { trigger: 'axis' },
                legend: {
                    top: 30,
                    data: ['尖段', '峰段', '平段', '谷段']
                },
                xAxis: {
                    type: 'category',
                    data: ['A站', 'B站', 'C站', 'D站', 'E站']
                },
                yAxis: { type: 'value' },
                series: [
                    {
                        name: '尖段',
                        type: 'bar',
                        stack: 'total',
                        data: [50, 45, 55, 40, 48],
                        itemStyle: { color: '#F56C6C' }
                    },
                    {
                        name: '峰段',
                        type: 'bar',
                        stack: 'total',
                        data: [200, 180, 220, 160, 190],
                        itemStyle: { color: '#E6A23C' }
                    },
                    {
                        name: '平段',
                        type: 'bar',
                        stack: 'total',
                        data: [150, 140, 160, 130, 145],
                        itemStyle: { color: '#409EFF' }
                    },
                    {
                        name: '谷段',
                        type: 'bar',
                        stack: 'total',
                        data: [90, 80, 95, 70, 85],
                        itemStyle: { color: '#67C23A' }
                    }
                ]
            })
        },

        renderHorizontalBar() {
            this.horizontalBar.setOption({
                title: { text: '用电时段占比', left: 'center' },
                tooltip: { trigger: 'axis' },
                xAxis: { type: 'value', max: 100 },
                yAxis: {
                    type: 'category',
                    data: ['谷段', '平段', '峰段', '尖段']
                },
                series: [
                    {
                        name: '占比(%)',
                        type: 'bar',
                        data: [22, 37, 41, 12],
                        itemStyle: { color: '#67C23A' }
                    }
                ]
            })
        },

        renderPieChartTotal() {
            this.pieChartTotal.setOption({
                title: { text: '总体用电构成', left: 'center' },
                tooltip: { formatter: '{b}：{c}kWh ({d}%)' },
                legend: { bottom: 10 },
                series: [
                    {
                        type: 'pie',
                        radius: '60%',
                        data: [
                            { value: 15800, name: '尖段' },
                            { value: 52300, name: '峰段' },
                            { value: 48100, name: '平段' },
                            { value: 28200, name: '谷段' }
                        ]
                    }
                ]
            })
        },

        renderPieChartStation() {
            this.pieChartStation.setOption({
                title: { text: '站点用电占比', left: 'center' },
                tooltip: { formatter: '{b}：{c}kWh ({d}%)' },
                legend: { bottom: 10 },
                series: [
                    {
                        type: 'pie',
                        radius: '60%',
                        data: [
                            { value: 32000, name: 'A站' },
                            { value: 28000, name: 'B站' },
                            { value: 26000, name: 'C站' },
                            { value: 22000, name: 'D站' },
                            { value: 20600, name: 'E站' }
                        ]
                    }
                ]
            })
        },

        renderPieChartSource() {
            this.pieChartSource.setOption({
                title: { text: '用电来源构成', left: 'center' },
                tooltip: { formatter: '{b}：{c}kWh ({d}%)' },
                legend: { bottom: 10 },
                series: [
                    {
                        type: 'pie',
                        radius: '60%',
                        data: [
                            { value: 85000, name: '市电' },
                            { value: 22000, name: '光伏' },
                            { value: 13000, name: '储能放电' },
                            { value: 8600, name: '其他' }
                        ]
                    }
                ]
            })
        }
    }
}
</script>

<style scoped>
.title {
    font-size: 18px;
    font-weight: bold;
}

.stat-title {
    font-size: 14px;
    color: #666;
}

.stat-value {
    font-size: 26px;
    font-weight: bold;
    margin: 8px 0;
}

.stat-desc {
    font-size: 12px;
    color: #999;
}

.mt-20 {
    margin-top: 20px;
}

.mb-20 {
    margin-bottom: 20px;
}
</style>